(function () {
  'use strict';

  var state = null;

  document.addEventListener('touchstart', onTouchStart, { passive: true, capture: true });
  document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
  document.addEventListener('touchend', onTouchEnd, { passive: true, capture: true });

  function getSwiperAt(x, y) {
    // Check that the topmost element at these coordinates belongs to the card,
    // not to an external dropdown/overlay covering the product card.
    var topEl = document.elementFromPoint(x, y);
    if (!topEl) return null;

    var swipers = document.querySelectorAll('.card-img-swiper');
    for (var i = 0; i < swipers.length; i++) {
      var s = swipers[i];
      var slides = s.querySelectorAll('.card-img-slide');
      if (slides.length <= 1) continue;
      var r = s.getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
        // The card wrapper contains both the swiper and the heading overlay link.
        // If topEl is not part of this card at all, something external is on top.
        var card = s.closest('.card-wrapper') || s.closest('.card') || s.parentElement;
        if (card && !card.contains(topEl)) continue;
        return { swiper: s, slides: slides };
      }
    }
    return null;
  }

  function isFilterDrawerOpen() {
    var drawer = document.querySelector('.mobile-facets__disclosure[open]');
    return !!drawer;
  }

  function onTouchStart(e) {
    if (isFilterDrawerOpen()) return;
    var t = e.touches[0];
    var found = getSwiperAt(t.clientX, t.clientY);
    if (!found) return;

    var activeSlide = found.swiper.querySelector('.card-img-slide.is-active');
    state = {
      swiper: found.swiper,
      slides: found.slides,
      startX: t.clientX,
      startY: t.clientY,
      currentIndex: activeSlide ? parseInt(activeSlide.dataset.index, 10) : 0,
      track: found.swiper.querySelector('.card-img-track'),
      dots: found.swiper.querySelectorAll('.card-img-dot'),
      moved: false,
      axis: null
    };
  }

  function onTouchMove(e) {
    if (!state) return;

    var dx = e.touches[0].clientX - state.startX;
    var dy = e.touches[0].clientY - state.startY;
    var adx = Math.abs(dx);
    var ady = Math.abs(dy);

    if (!state.axis) {
      if (adx > ady && adx > 3) {
        state.axis = 'x';
        // Disable CSS transition during drag for real-time feedback
        if (state.track) state.track.style.transition = 'none';
      } else if (ady > adx && ady > 3) {
        state = null;
        return;
      } else {
        // Gesto aún ambiguo — no bloquear scroll vertical
        return;
      }
    }

    if (state.axis === 'x') {
      e.preventDefault();
      state.moved = true;
      // Move track in real-time following the finger
      if (state.track) {
        var pct = (dx / state.swiper.offsetWidth) * 100;
        // Add resistance at the edges (first/last image)
        if ((state.currentIndex === 0 && dx > 0) || (state.currentIndex === state.slides.length - 1 && dx < 0)) {
          pct = pct * 0.25; // rubber-band effect at edges
        }
        state.track.style.transform = 'translateX(' + (-state.currentIndex * 100 + pct) + '%)';
      }
    }
  }

  function onTouchEnd(e) {
    if (!state) return;

    if (!state.moved) {
      // Tap — navigate to product
      var url = state.swiper.dataset.url;
      if (url) window.location.href = url;
      state = null;
      return;
    }

    if (state.axis !== 'x') {
      state = null;
      return;
    }

    var dx = e.changedTouches[0].clientX - state.startX;
    var threshold = Math.min(state.swiper.offsetWidth * 0.25, 60); // 25% of card width or 60px
    var next = state.currentIndex;

    if (Math.abs(dx) > threshold) {
      next = state.currentIndex + (dx < 0 ? 1 : -1);
      next = Math.max(0, Math.min(state.slides.length - 1, next));
    }

    goTo(state.slides, state.track, state.dots, next);
    state = null;
  }

  function goTo(slides, track, dots, index) {
    slides.forEach(function (slide) {
      slide.classList.remove('is-active');
    });
    slides[index].classList.add('is-active');

    if (track) {
      track.style.transition = ''; // restore CSS transition (from card-image-swipe.css)
      track.style.transform = 'translateX(-' + index * 100 + '%)';
    }

    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  // iOS: remove -webkit-overflow-scrolling:touch from parent sliders
  function initAll() {
    document.querySelectorAll('.card-img-swiper').forEach(function (swiper) {
      if (swiper.querySelectorAll('.card-img-slide').length <= 1) return;
      var slider = swiper.closest('.slider');
      if (slider) slider.style.webkitOverflowScrolling = 'auto';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var swipers = node.classList && node.classList.contains('card-img-swiper')
          ? [node]
          : (node.querySelectorAll ? Array.from(node.querySelectorAll('.card-img-swiper')) : []);
        swipers.forEach(function (swiper) {
          if (swiper.querySelectorAll('.card-img-slide').length <= 1) return;
          var slider = swiper.closest('.slider');
          if (slider) slider.style.webkitOverflowScrolling = 'auto';
        });
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

})();
